<template>
	<div class="panel">
		<form class="wrap container1" @submit.prevent="order">
			<div class="total">
				<div class="sub">Total inkl. moms:</div>
				<div class="price">DKK&nbsp;&nbsp;&nbsp;{{price}}</div>
			</div>
			<div class="terms">
				<input id="terms" type="checkbox" required/>
				<div class="label">Accepter <a @click="terms = true">handelsbetingelser</a></div>
			</div>
			<button type="submit" class="button">Afgiv bestilling</button>
		</form>

		<terms v-if="terms" @close="terms = false"/>
	</div>
</template>

<script>
import {price} from "@/modules/utils";
import terms from "./terms.vue";

export default {
	components: {terms},
	data() {
		return {
			terms: false
		}
	},
	computed: {
		cart: (t) => t.$store.getters["cart/data"],
		price: (t) => price(t.cart.total_price)
	},
	methods: {
		async order() {
			await this.$store.dispatch("cart/saveOrder");
		}
	}
};
</script>

<style lang="scss" scoped>
.panel {
	z-index: 3;
	position: fixed;
	bottom: 0;
	left: 0;
	right: 0;
	height: 73px;
	background-color: #636464;
	color: $white1;

	@include res(xsmall) {
		height: 116px;;
	}

	.wrap {
		height: 100%;
		width: 100%;
		display: flex;
		align-items: center;
		justify-content: space-between;

		@include res(xsmall) {
			flex-direction: column;
			justify-content: center;
		}

		.total {
			@include res(xsmall) {
				display: none;
			}

			.sub {
				font-size: 12px;
				margin-bottom: 3px;
				font-weight: 300;
			}
			.title {
				font-size: 18px;
				font-weight: 500;
			}
		}

		.terms {
			margin-left: auto;
			margin-right: 56px;
			display: flex;
			align-items: center;

			@include res(xsmall) {
				margin: 0;
				margin-bottom: 1.2em;
			}

			input {
				margin-top: -0.1em;
			}

			.label {
				margin-left: 1em;

				a {
					color: $white1;
					text-decoration: underline;
				}
			}
		}

		.button {
			cursor: pointer;
			appearance: none;
			border: 0px;
			width: 172px;
			user-select: none;
			box-shadow: 0 1px 0 0 rgba(22, 29, 37, 0.10000000149011612), inset 0 1px 0 1px rgba(255, 255, 255, 0.05999999865889549);
			display: flex;
			align-items: center;
			justify-content: center;
			outline: none;
			height: 36px;
			font-size: 14px;
			background: #1A1919;
			color: $white1;
			font-weight: 500;
			letter-spacing: 1px;
			border-radius: 3px;

			@include res(xsmall) {
				width: 100%;
			}
		}
	}
}
</style>
